import type { RouteObject } from 'react-router-dom'

const settingsRoute: RouteObject = {
  children: [
    // { path: 'companies', lazy: () => import('@/pages/settings/companies/index/page') },
    { path: 'company', lazy: () => import('@/pages/settings/company/page') },
    { path: 'companies/:id/edit', lazy: () => import('@/pages/settings/companies/edit/page') },

    { path: 'work-locations', lazy: () => import('@/pages/settings/work-locations/index/page') },
    { path: 'work-locations/create', lazy: () => import('@/pages/settings/work-locations/create/page') },
    { path: 'work-locations/:id/edit', lazy: () => import('@/pages/settings/work-locations/edit/page') },

    // { path: 'identity-types', lazy: () => import('@/pages/settings/identity-types/index/page') },
    // { path: 'identity-types/create', lazy: () => import('@/pages/settings/identity-types/create/page') },
    // { path: 'identity-types/:id/edit', lazy: () => import('@/pages/settings/identity-types/edit/page') },

    { path: 'organization-structure', lazy: () => import('@/pages/settings/organization-structure/index/page') },
    { path: 'organization-structure/level', lazy: () => import('@/pages/settings/organization-structure/level/page') },

    { path: 'departments', lazy: () => import('@/pages/settings/departments/page') },
    { path: 'positions', lazy: () => import('@/pages/settings/positions/page') },
    { path: 'job-levels', lazy: () => import('@/pages/settings/job-levels/page') },
    { path: 'employment-status', lazy: () => import('@/pages/settings/employment-status/page') },
    { path: 'document-request', lazy: () => import('@/pages/settings/document-request/page') },
    { path: 'permissions', lazy: () => import('@/pages/settings/permissions/page') },
    { path: 'permission-groups', lazy: () => import('@/pages/settings/permission-groups/page') },
    { path: 'work-placements', lazy: () => import('@/pages/settings/work-placements/page') },
    // { path: 'holidays', lazy: () => import('@/pages/settings/holiday/page') },
    // { path: 'holidays/create', lazy: () => import('@/pages/settings/holiday/create/page') },
    // { path: 'holidays/:holidayId', lazy: () => import('@/pages/settings/holiday/edit/page') },
    { path: 'master-upload', lazy: () => import('@/pages/settings/master-upload/page') },
    { path: 'grades', lazy: () => import('@/pages/settings/grade/page') },
    { path: 'reason', lazy: () => import('@/pages/settings/reason/page') },
    { path: 'letter-templates', lazy: () => import('@/pages/settings/letter-templates/page') },
    { path: 'email-templates', lazy: () => import('@/pages/settings/email-templates/page') },
  ],

  path: 'settings',
}

export default settingsRoute
